import Player from '@vimeo/player';
import { addClass, removeClass } from '../config.js';

const foregroundVideoVisibleClass = 'foreground-video-visible';
const backgroundVideoVisibleClass = 'background-video-visible';
const shiftDownClass = 'shift-down'
const transparentOverlayClass = 'transparent-overlay'
const hideOnShowReelClass = 'hide-on-showreel'
const iframeTag = 'iframe';

export const initalizeShowreels = () => {
    const showreels = document.querySelectorAll('.js-showreel');
    if (!showreels.length) return;

    showreels.forEach(initalizeShowreel);
}

const initalizeShowreel = (showreel) => {
    const showreelButton = showreel.querySelector('.js-play-showreel-button');
    const backgroundVideo = showreel.querySelector('.js-background-video');
    const foregroundVideo = showreel.querySelector('.js-foreground-video');
    const hideShowReelButton = showreel.querySelector('.js-hide-showreel-button');
    const shiftDown = showreel.querySelector('.js-shift-down');
    const transparentOverlay = showreel.querySelector('.js-transparent-overlay');
    const hideOnShowReel = showreel.querySelector('.js-hide-on-showreel');
    const showreelDescription = showreel.querySelector('.js-showreel-description');

    if (!showreelButton || !backgroundVideo || !foregroundVideo || !hideShowReelButton) {
        return;
    }

    const backgroundIframe = backgroundVideo.querySelector(iframeTag);
    const backgroundVimeo = new Player(backgroundIframe);

    const foregroundIframe = foregroundVideo.querySelector(iframeTag);
    const foregroundVimeo = new Player(foregroundIframe);
    let foregroundVideoInFocus = false;

    showreelButton.addEventListener('click', () => {
        removeClass(backgroundVideo, backgroundVideoVisibleClass);
        addClass(foregroundVideo, foregroundVideoVisibleClass);
        addClass(foregroundVideo.parentElement, foregroundVideoVisibleClass);
        addClass(shiftDown, shiftDownClass);
        removeClass(transparentOverlay, transparentOverlayClass);
        addClass(hideOnShowReel, hideOnShowReelClass);

        backgroundVimeo.pause();
        foregroundVimeo.setCurrentTime(0);
        foregroundVimeo.setVolume(1);
        foregroundVimeo.play();
        foregroundVideoInFocus = true;
        showreelDescription.classList.add('showreel-playing');
    });

    hideShowReelButton.addEventListener('click', () => {
        addClass(backgroundVideo, backgroundVideoVisibleClass);
        removeClass(foregroundVideo, foregroundVideoVisibleClass);
        removeClass(foregroundVideo.parentElement, foregroundVideoVisibleClass);
        removeClass(shiftDown, shiftDownClass);
        addClass(transparentOverlay, transparentOverlayClass);
        removeClass(hideOnShowReel, hideOnShowReelClass);

        backgroundVimeo.play();
        foregroundVimeo.pause();
        foregroundVideoInFocus = false;
        showreelDescription.classList.remove('showreel-playing');
    });

    let pausedByScroll = false;
    let pausedByUser = false;
    foregroundVimeo.on('play', () => pausedByUser = false);
    foregroundVimeo.on('pause', () => {
        if (!pausedByScroll) {
            pausedByUser = true;
        }
    });

    window.addEventListener('scroll', () => {
        if (!foregroundVideoInFocus || pausedByUser) return;

        const rect = foregroundIframe.getBoundingClientRect();
        const isScrolledAbove = rect.top > window.innerHeight;
        const isScrolledBelow = rect.bottom < 0;

        if (isScrolledAbove || isScrolledBelow) {
            pausedByScroll = true;
            foregroundVimeo.pause();
        } else {
            pausedByScroll = false;
            foregroundVimeo.play();
        }
    });
}
